import { writable } from 'svelte/store';

// 1. Definimos la estructura inicial por defecto
const rttPaneListMesasConfig = {
    settings: {
    realtime: false,
    mesasActivas: false,
    realtimefirebase: false,
  }
};

function createStorageStore() {
    // Recuperar datos existentes o usar la estructura inicial
    const saved = localStorage.getItem('rttPaneListMesasConfig');

    
    const data = saved ? JSON.parse(saved) : rttPaneListMesasConfig;

    const { subscribe, set, update } = writable(data);

    return {
        subscribe,
        // Agregar datos si no existen (Merge manual)
        initialize: (key, value) => update(n => {
            if (!n[key]) {
                n[key] = value;
            }
            return n;
        }),
        updateSettings: (settings) => update(n => {
            n.settings = settings;
            return n;
            
        }),
        // Guardar manualmente en LocalStorage
        save: (currentValue) => {
            localStorage.setItem('rttPaneListMesasConfig', JSON.stringify(currentValue));
        },
        reset: () => {
            localStorage.setItem('rttPaneListMesasConfig', JSON.stringify(rttPaneListMesasConfig));
            set(rttPaneListMesasConfig);
        }
    };
}

export const paneListMesasConfig = createStorageStore();

// Suscripción automática para guardar en LocalStorage cada vez que cambie
paneListMesasConfig.subscribe(value => {
    localStorage.setItem('rttPaneListMesasConfig', JSON.stringify(value));
});


